import { PatientCreateResponseMapper } from "@/data/mapper/patient-create-response-mapper";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { UserInfoMapper } from "@/data/mapper/user-info-mapper";
import { CreatePatientWithGuardianPayload } from "@/data/payload/create-patient-with-guardian-payload";
import { ChangePasswordRequestPayload } from "@/data/payload/user/change-password-request-payload";
import { ResendSMSForSetupAccountRequestPayload } from "@/data/payload/user/re-send-sms-for-setup-account-request-payload";
import { PatientSource } from "@/data/source/patient-source";
import { UserSource } from "@/data/source/user-source";
import { CreatePatientResponseEntity } from "@/domain/entity/create-patient-response-entity";
import { UserInfoEntity } from "@/domain/entity/user-info-entity";
import { UserRepository } from "@/domain/repository/user-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class UserRepositoryImpl implements UserRepository {
  userSource: UserSource;
  patientSource: PatientSource;

  constructor(userSource: UserSource, patientSource: PatientSource) {
    this.userSource = userSource;
    this.patientSource = patientSource;
  }

  async getUserInfo(): Promise<SATResult<UserInfoEntity, SATError>> {
    const result = await this.userSource.getUserInfo();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    console.log("[UserRepositoryImpl] :: getUserInfo :: 사용자 정보 조회 성공");
    return safeMapToEntity(
      result.value,
      UserInfoMapper.toEntity,
      "UserRepositoryImpl::getUserInfo"
    );
  }

  async createPatientWithGuardian(
    payload: CreatePatientWithGuardianPayload
  ): Promise<SATResult<CreatePatientResponseEntity, SATError>> {
    const result = await this.userSource.createPatientWithGuardian(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    console.log(
      "[UserRepositoryImpl] :: createPatientWithGuardian :: 환자 등록 성공 :: response",
      result.value
    );
    return safeMapToEntity(
      result.value,
      PatientCreateResponseMapper.toEntity,
      "UserRepositoryImpl::createPatientWithGuardian"
    );
  }

  async changePasswordWhenLogin(
    payload: ChangePasswordRequestPayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.userSource.changePasswordWhenLogin(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async sendSMSForSetupAccount(
    payload: ResendSMSForSetupAccountRequestPayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.userSource.resendSMSForSetupAccount(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
